// extracted by mini-css-extract-plugin
export default {"privacy":"privacy_privacy__-ebGL","about":"privacy_about__XmyaQ"};